<template>
  <!-- Loading state of an event app tab (design-system look): EmbedFrame while the embedded page
       loads, SectionTabs while a tab switch waits for the server. -->
  <div
    class="flex flex-col items-center justify-center gap-3 bg-(--ds-surface-app)"
    role="status"
  >
    <span
      class="size-8 animate-spin rounded-full border-[3px] border-(--ds-surface-brand) border-t-(--ds-action-brand)"
      aria-hidden="true"
    />
    <span
      class="text-(length:--ds-font-size-md) font-medium text-(--ds-text-secondary)"
      v-text="$t('common.loading')"
    />
  </div>
</template>
